module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS14.a5fb74a8.jpg";